<template>
    <div v-if="hasMessages" class="form-field--message-container">
        <span class="form-field--message form-field--message__error"
                v-if="hasErrorMessages"
                v-for="(message, messageIdx) in messages.error" key="messageIdx"
                v-html="message">
        </span>
        <span class="form-field--message form-field--message__info"
                v-if="hasInfoMessages"
                v-for="(message, messageIdx) in infoMessages" key="messageIdx"
                v-html="message">
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            messages: {
                type: Object,
                default() {
                    return {};
                },
            },
            activeItem: Object,
        },
        computed: {
            hasErrorMessages() {
                return Array.isArray(this.messages.error) && !!this.messages.error.length;
            },
            hasInfoMessages() {
                return !!this.infoMessages.length;
            },
            hasMessages() {
                return this.hasErrorMessages || this.hasInfoMessages;
            },
            infoMessages() {
                return [
                    this.messages.info,
                    this.activeItem && this.activeItem.info,
                ].filter(Boolean);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/form/partials/form-field-messages-partial/index.vue?3a941868